import React, { Component } from 'react';
import './index.scss';
import { observer } from 'mobx-react';
import store from '../../stores/category-store';
import { createHashHistory } from 'history';
import { Tabs, WhiteSpace } from 'antd-mobile';


class Header extends Component {
  constructor(props, context){
    super(props);
    this.state = {
      showLoading : false,
    }
  }
  componentWillMount(){
  }
  componentDidMount(){
  }
  componentWillUpdata(){
  }
  
  render() {
    function SubTabs(props) {
      const deep = props.deep;
      const loaded = props.loaded;
      const tabs = props.tabs;
      if(deep === 2){
        if(loaded === true){
          return <Tabs 
            tabs={tabs}
            animated={false}
            prefixCls="sub-tabs-style"
            prerenderingSiblingsNumber
            onChange={(tab,index)=>{
              // console.log('onThirdCatClick', index, tab);
              store.thirdCat = tab.catId;
              store.switchTab({thirdCat:tab.catId});
              window._rlog.push([ "_trackCustom" , "EVENT", [['action', 'click_thirdCat'],['secondCat', tab.catId]] ]);
              createHashHistory().push('/CategoryList?superId='+ store.topCat +'&subCatId='+store.secondCat+'&thirdCat='+tab.catId+'&deep='+ tab.deep +'&title=' + encodeURIComponent(store.pageTitle));
            }}

            destroyInactiveTab={true}
            initialPage={0}
          >
          </Tabs>
          
        }else{
          return <div className="placeholder-tab"></div>
        }
      }
      return null;
      
    }
    
    return (
      <div className="detail-category-header" style={{ height: '100%' }}>
       {/* {store.activeSecondTab} */}
        <WhiteSpace/>
          <Tabs 
            tabs={store.topCatList}
            onChange={(tab,index)=>{
              // console.log('onSecondTabClick', index, tab);
              store.secondCat = tab.catId;
              store.selectSecondCat(tab.catId);
              store.switchTab({secondCat:tab.catId,thirdCat:0});
              store.deep = tab.deep;
              window._rlog.push([ "_trackCustom" , "EVENT", [['action', 'click_secondCat'],['secondCat', tab.catId]] ]);
              createHashHistory().push('/CategoryList?superId='+ store.topCat +'&subCatId='+tab.catId+'&deep='+ tab.deep +'&title=' + encodeURIComponent(store.pageTitle));
              
            }}
            initialPage={store.activeSecondTab}
            prefixCls={ window.isHeightRatio ? 'tabs-style hairlines' : "tabs-style" }
            renderTabBar={props => <Tabs.DefaultTabBar {...props} page={4} />}
            // swipeable={false}
            // prerenderingSiblingsNumber
          >
          </Tabs>
          
          {
            window.isHeightRatio && 
            <div>hairlines</div>
          }
          
        <WhiteSpace size="xl"/>
        <SubTabs deep={store.deep} loaded={store.loaded} tabs={store.subCatList}/>
        
      </div>
    );
  }
}

export default observer(Header);